import { FaceLandmarker as FaceLandmarkerImpl, FilesetResolver} from '@mediapipe/tasks-vision'



export async function FaceLandmarker({ basePath , options, fileset }) {

    const vision = fileset || await FilesetResolver.forVisionTasks(basePath)
    const faceLandmarker = await FaceLandmarkerImpl.createFromOptions(vision, options)
    return {faceLandmarker, vision}

}


